export default __webpack_public_path__ + "static/media/SEC1740.34I-40992_-24350_0.efe29146.jpg";